import React from "react";

export default function TextField({
  label,
  type = "text",
  value,
  onChange,
  id,
  style,
  classNameBox,
  className,
}) {
  return (
    <div style={{ color: "#fff" }} className={`inputGroup ${classNameBox}`}>
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        style={style}
        required
        autoComplete="off"
        className={className}
      />
      <label style={{ color: "#fff" }} htmlFor={id}>
        {label}
      </label>
    </div>
  );
}
